import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { drawerContent, wrapperContentWithBackground } from "../../styles/GlobalStyles";
import { Outlet } from "react-router-dom";

const useStyles = makeStyles({
    drawerContent,
    wrapperContentWithBackground
});

export const PublicWrapper: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <div id="publicContent" className={styles.drawerContent}>
            <div id="publicOutlet" className={styles.wrapperContentWithBackground}>
                <Outlet />
            </div>
        </div>
    );
});
